import script from "./ImportManualAppraisalsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportManualAppraisalsPage.vue?vue&type=script&setup=true&lang=js"

import "./ImportManualAppraisalsPage.vue?vue&type=style&index=0&id=089957dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-089957dc"]])

export default __exports__